import { Icon } from "@iconify/react";
import Modal from "../UI/Modal";
import { useSelector, useDispatch } from "react-redux";
import { closeTalentView } from "../../store/reducers/plantels/talentsByPlantels.reducer";
import Loader from "../UI/Loader";
import Field from "../UI/Field";
import AuditInfo from "../UI/AuditInfo";

const TalentByPlantelViewModal = () => {
  const dispatch = useDispatch();

  const { viewTalentModalOpen, selectedTalent, selectedTalentLoading } =
    useSelector((state) => state.talentosByPlantels);

  const handleClose = () => {
    dispatch(closeTalentView());
  };

  return (
    <Modal
      open={viewTalentModalOpen}
      title="Detalle del talento"
      size="xl"
      onClose={handleClose}
    >
      {selectedTalentLoading ? (
        <div className="text-center py-5">
          <Loader type="spinner" size="lg" delay={0} />
        </div>
      ) : selectedTalent ? (
        <div className="row g-4">
          {/* Columna izquierda */}
          <div className="col-md-6">
            <div className="d-flex flex-column gap-3">
              <Field
                label="Nombre"
                value={selectedTalent.nombre}
                icon="mdi:star-outline"
              />

              <Field
                label="Estado"
                value={
                  selectedTalent.is_active ? (
                    <span className="badge bg-success-subtle text-success">
                      <Icon
                        icon="mdi:check-circle"
                        width="14"
                        height="14"
                        className="me-1"
                      />
                      Activo
                    </span>
                  ) : (
                    <span className="badge bg-danger-subtle text-danger">
                      <Icon
                        icon="mdi:close-circle"
                        width="14"
                        height="14"
                        className="me-1"
                      />
                      Inactivo
                    </span>
                  )
                }
                icon="mdi:toggle-switch"
              />
            </div>
          </div>

          {/* Columna derecha */}
          <div className="col-md-6">
            <div className="d-flex flex-column gap-3">
              <Field
                label="Descripción"
                value={selectedTalent.descripcion}
                icon="mdi:text-box-outline"
                justify
              />
            </div>
          </div>

          {/* Auditoría */}
          <div className="col-12">
            <AuditInfo
              createdAt={selectedTalent.created_at}
              updatedAt={selectedTalent.updated_at}
              createdBy={selectedTalent.created_by}
              updatedBy={selectedTalent.updated_by}
            />
          </div>
        </div>
      ) : (
        <div className="text-center py-5">
          <Icon
            icon="mdi:alert-circle"
            width="48"
            height="48"
            className="text-muted"
          />
          <p className="text-muted mt-3">
            No se pudo cargar la información del talento
          </p>
        </div>
      )}
    </Modal>
  );
};

export default TalentByPlantelViewModal;
